import { getAPI, postAPI } from "../../api/api"
import { REACT_APP_TIMESHEET, REACT_APP_JOB, REACT_APP_CUSTOMER, REACT_APP_CUSTOMERSETTINGS, REACT_APP_JOBFILTER } from "../../utils/common"


export async function listCandidateTimeSheetList(pageNumber?: number, pageSize?: number, search?: string, body?: any) {
    const Details = postAPI(REACT_APP_TIMESHEET + `/candidate-timesheet-list?page=${pageNumber}&size=${pageSize}&search=${search}`, body)
    return Details
}

export async function getHistory(timesheetId: string) {
    const Details = getAPI(REACT_APP_TIMESHEET + `/timesheet-status-history/${timesheetId}`)
    return Details
}

export async function sendTimesheetReminder(body: any) {
    const Details = postAPI(REACT_APP_TIMESHEET + '/timesheet-reminder', body)
    return Details
}

export async function sendTimesheetApprovalReminder(body: any) {
    const Details = postAPI(REACT_APP_TIMESHEET + '/timesheet-approval-reminder', body)
    return Details
}

export async function getpositionsName() {
    const Details = getAPI(REACT_APP_JOBFILTER + "/position-title")
    return Details
}

export async function getCompany() {
    const Details = getAPI(REACT_APP_CUSTOMER + "/customer-list")
    return Details
}
export async function getProviderEmailList(candidateId: string) {
    const Details = getAPI(REACT_APP_CUSTOMERSETTINGS + `/getProviderDetails/${candidateId}`)
    return Details
}
export async function getListTimesheetDetails(body: string) {
    const Details = postAPI(REACT_APP_TIMESHEET + `/listTimesheetDetails`, body)
    return Details
}

